<!-- /*--############################################################################
  # Filename : MST37_072INS.vue                                               
  # Description : 마스터관리 > 메뉴 마스터 > 옵션 관리   
  # Date :2026-04-10                                                        
  # Author : 권지안                     
################################################################################*/ -->
<template>
  <!-- 조회 조건  -->
  <div class="flex justify-between items-center w-full overflow-y-hidden">
    <PageName></PageName>
    <div class="flex justify-center mr-10 space-x-2 pr-5">
      <button @click="searchButton" class="button search md:w-auto w-14">
        조회
      </button>
      <button @click="saveButton" class="button save w-auto">저장</button>
    </div>
  </div>
  <br />
  <div class="bg-gray-200 rounded-lg px-2 py-2">
    <div class="flex justify-start items-center">
      <PickStore
        @update:storeGroup="handleGroupCd"
        @update:storeCd="handleStoreCd"
        @storeNm="handlestoreNm"
        :hidesub="hidesub"
        :hideAttr="hideAttr"
        @GroupNm="handleGroupNm"
        @update:ischanged="handleinitAll">
      </PickStore>
    </div>
    <div
      v-if="isStoreScopeFeatureEnabled"
      class="flex justify-start items-center text-base font-semibold text-black mt-2 ml-12 space-x-3">
      <div>
        공통 여부
      </div>
      <select
        v-model="dataScope"
        class="border rounded-lg h-9 px-2 bg-white w-44 text-sm">
        <option value="COMMON">공통(그룹)</option>
        <option value="STORE">매장별</option>
      </select>
      <div>
        저장 매장
      </div>
      <v-select
        v-model="scopeStoreCd"
        :options="scopeStoreOptions"
        label="strName"
        placeholder="선택"
        class="scope-store-select w-72 bg-white text-sm"
        :clearable="false"
        :disabled="dataScope !== 'STORE'"
        :reduce="(item) => String(item.lngStoreCode)" />
    </div>
  </div>
  <!-- 조회 조건  -->
  <!--그리드 영역 및 연동 데이터 영역 -->
  <div
    v-if="addMenu"
    class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded shadow-lg w-[60%] h-[60%]">
      <h1 class="text-2xl font-bold flex justify-start">메뉴 조회 팝업</h1>
      <div class="flex flex-col justify-start h-12">
        <div class="flex flex-col justify-start space-x-4 text-sm">
          <div
            class="flex items-center justify-start font-bold text-sm pl-1 mt-3 gap-5">
            <div>
              법인 :
              <select
                disabled
                class="border border-gray-800 rounded-md p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                <option>[{{ groupCd }}]{{ selectedGroupNm }}</option>
              </select>
            </div>
            <div v-if="hidesub">
              매장명 :
              <select
                disabled
                class="border border-gray-800 rounded-md p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                <option>[{{ nowStoreCd }}]{{ clickedStoreNm }}</option>
              </select>
            </div>
            <div>
              메뉴구분 :
              <select
                class="border border-gray-800 rounded-md p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                v-model="menuSort">
                <option value="0">전체</option>
                <option value="일반">일반메뉴</option>
                <option value="세트">세트메뉴</option>
              </select>
            </div>
            <div>
              배달구분 :
              <select
                class="border border-gray-800 rounded-md p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                v-model="deliverySort">
                <option value="0">전체</option>
                <option value="일반">일반</option>
                <option value="배달">배달</option>
              </select>
            </div>
          </div>
          <div
            class="flex items-center justify-start font-bold text-sm mt-3 gap-5">
            <div
              class="flex gap-5 items-center justify-start font-bold text-sm -ml-3">
              메뉴분류 :
              <select
                name=""
                id=""
                class="border w-48 border-gray-800 rounded-md p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                v-model="mainCategory">
                <option value="0">전체</option>
                <option :value="i.lngCode" v-for="i in MenuGroup">
                  {{ i.strName }}
                </option>
              </select>
              <select
                name=""
                id=""
                class="border w-48 border-gray-800 rounded-md p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                v-model="subCategory">
                <option value="0">전체</option>
                <option :value="i.lngCode" v-for="i in filteredSubMenuGroup">
                  {{ i.strName }}
                </option>
              </select>
              메뉴명 :
              <input
                type="text"
                v-model="searchword3"
                @input="searchWord3"
                class="border border-gray-800 rounded-lg shadow-lg pl-1 h-8" />
            </div>
          </div>
        </div>
      </div>
      <div class="w-[100%] h-[60%] mt-16">
        <Realgrid
          class="w-full h-full mt-2"
          :progname="'MST01_011INS_01_VUE'"
          :progid="5"
          :rowData="rowData5"
          @clickedRowData="clickedRowData3"
          :searchWord="searchword3"
          :rowStateeditable="false"
          :searchColId="'lngCode,strName'"
          :searchColId2="'blnSetMenu,blnDeliveryYN,mainLngCode,subLngCode'"
          :searchColValue2="searchColValue2"
          @dblclickedRowData="dblclickedRowData"
          :selectionStyle="'singleRow'"></Realgrid>
      </div>
      <div class="flex justify-center space-x-3 w-full h-16 mt-5">
        <button
          @click="clickaddMenu1(selectedaddMenu)"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          추가
        </button>
        <button
          @click="closeMenus"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          닫기
        </button>
      </div>
    </div>
  </div>

  <div
    v-if="selectMenuGroup"
    class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded shadow-lg w-[60%] h-[60%]">
      <h1 class="text-2xl font-bold flex justify-start">옵션 조회 팝업</h1>
      <div class="flex flex-col justify-start h-12">
        <div class="flex flex-col justify-start space-x-4 text-sm">
          <div
            class="flex items-center justify-start font-bold text-sm pl-1 mt-3 gap-5">
            <div>
              법인 :
              <select
                disabled
                class="border border-gray-800 rounded-md p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                <option>[{{ groupCd }}]{{ selectedGroupNm }}</option>
              </select>
            </div>
            <div>
              매장명 :
              <select
                disabled
                class="border border-gray-800 rounded-md p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                <option>[{{ nowStoreCd }}]{{ clickedStoreNm }}</option>
              </select>
            </div>
            <div>
              그룹코드/그룹명:
              <input
                type="text"
                @input="searchWord4"
                class="border border-gray-800 rounded-lg shadow-lg pl-1 h-8" />
            </div>
          </div>
        </div>
      </div>
      <div class="w-[100%] h-[60%] mt-16">
        <Realgrid
          class="w-full h-full mt-2"
          :progname="'MST01_011INS_01_VUE'"
          :progid="1"
          :rowData="rowData6"
          @clickedRowData="clickedRowData4"
          :searchWord3="searchword4"
          :searchColId="'lngCode,strName'"
          @dblclickedRowData="dblclickedRowData2"
          :selectionStyle="'singleRow'"
          :rowStateeditable="false"></Realgrid>
      </div>
      <div class="flex justify-center space-x-3 w-full h-16 mt-5">
        <button
          @click="clickaddMenu2(selectedaddMenu2)"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          추가
        </button>
        <button
          @click="closeMenus2"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          닫기
        </button>
      </div>
    </div>
  </div>

  <span
    class="h-5 mt-3 flex justify-between items-center w-[900px] ml-[70%] z-40">
    <h1 class="font-bold text-xl z-40">
      옵션 {{ currentMenu == true ? "그룹" : "" }} 정보
    </h1>
  </span>
  <div class="flex h-4/5 w-full -mt-5">
    <div class="flex flex-col w-full h-full">
      <div
        class="flex justify-between mt-0 ml-10 w-[65%] border-b border-b-gray-300">
        <div>
          <button
            class="contents_tab-button"
            :class="{ 'text-blue-600': currentMenu == false }"
            @click="showMenus(1)">
            옵션관리
          </button>
          <button
            class="contents_tab-button"
            :class="{ 'text-blue-600': currentMenu == true }"
            @click="showMenus(2)">
            옵션그룹관리
          </button>
        </div>
        <div class="mt-3 gap-1 flex">
          <!-- <button class="whitebutton" @click="searchMenuList3">조회</button> -->
          <button
            class="whitebutton"
            v-if="currentMenu == false"
            @click="addRowData1">
            추가
          </button>
          <button
            class="whitebutton"
            v-if="currentMenu == false"
            @click="deleteRowData1">
            삭제
          </button>
          <button
            class="whitebutton"
            v-if="currentMenu == true"
            @click="addRowData3">
            추가
          </button>
          <button
            class="whitebutton"
            v-if="currentMenu == true"
            @click="deleteRowData3">
            삭제
          </button>
        </div>
      </div>
      <div class="flex h-full w-full gap-10">
        <div class="h-4/6 w-2/3" v-show="currentMenu == false">
          <div
            class="mt-3 ml-10 grid grid-cols-[1fr,3fr] grid-rows-1 gap-0 w-full">
            <div class="customtableIndex border border-gray-400 rounded-l-lg">
              옵션코드/옵션명
            </div>
            <div class="px-1 py-1 border border-gray-300 rounded-r-lg">
              <input
                type="text"
                class="border w-full h-full px-1 border-gray-400 rounded-lg"
                @input="searchOption"
                v-model="searchword1" />
            </div>
          </div>
          <div class="ml-10 mt-5 w-full h-[140%]">
            <!-- 옵션관리 그리드-->
            <Realgrid
              class="w-full h-full mt-2"
              :progname="'MST01_011INS_01_VUE'"
              :progid="1"
              :rowData="rowData1"
              @clickedRowData="clickedRowData"
              @updatedRowData="updatedRowData3"
              @updatedRowData2="updatedRowData3"
              @sendRowState="sendRowState"
              @allStateRows="allStateRows"
              :changeRow="changeRow"
              :changeNow2="changeNow"
              :changeNow="changeNow3"
              :changeColid="changeColid"
              :changeValue2="changeValue"
              :searchWord3="searchword1"
              :labelingColumns="'blnMustSel'"
              :labelsData="labelData"
              :valuesData="valueData"
              :searchColId="'lngCode,strName'"
              :deleteRow6="deleterow1"
              :addRow5="addrow1"
              @selectedIndex2="selectedIndex"
              @realgridname="realgridname"
              :addrowProp="addrowProp"
              :addrowDefault="',,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,'"
              :selectionStyle="'singleRow'"
              :rowStateeditable="false"
              :initSelect="initSelect"
              :addField="'new'">
            </Realgrid>
          </div>
        </div>

        <div class="h-4/6 w-2/3" v-show="currentMenu == true">
          <div
            class="mt-3 ml-10 grid grid-cols-[1fr,3fr] grid-rows-1 gap-0 w-full">
            <div class="customtableIndex border border-gray-400 rounded-l-lg">
              옵션그룹코드/옵션그룹명
            </div>
            <div class="px-1 py-1 border border-gray-300 rounded-r-lg">
              <input
                type="text"
                class="border w-full h-full px-1 border-gray-400 rounded-lg"
                @input="searchOption2"
                v-model="searchword2" />
            </div>
          </div>
          <div class="ml-10 mt-5 w-full h-[140%]">
            <!-- 옵션그룹관리 그리드-->
            <Realgrid
              class="w-full h-full mt-2"
              :progname="'MST01_011INS_01_VUE'"
              :progid="2"
              :rowData="rowData3"
              @clickedRowData="clickedRowData2"
              @updatedRowData="updatedRowData6"
              @updatedRowData2="updatedRowData6"
              @allStateRows="allStateRows2"
              :deleteRow6="deleterow2"
              :searchColId="'lngCode,strName'"
              :searchWord3="searchword2"
              :changeRow="changeRow2"
              :changeValue2="changeValue2"
              :changeNow2="changeNow2"
              :changeNow="changeNow4"
              @sendRowState="sendRowState2"
              :changeColid="changeColid"
              :addRow5="addrow3"
              @selectedIndex2="selectedIndex2"
              :addrowProp="addrowProp2"
              :addrowDefault="',,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,'"
              :selectionStyle="'singleRow'"
              :rowStateeditable="false"
              :initSelect="initSelect"
              @realgridname="realgridname2"
              :addField="'new'"></Realgrid>
          </div>
        </div>

        <div
          class="h-full w-1/3 flex flex-col pl-10"
          v-show="currentMenu == false">
          <div
            class="grid grid-cols-[1fr,3fr] grid-rows-4 items-center w-full h-1/5 rounded-lg">
            <div
              class="border border-black p-2 w-full h-full rounded-tl-lg flex items-center justify-center text-blue-500 font-semibold bg-gray-100">
              *옵션코드
            </div>
            <div
              class="border border-black p-2 w-full h-full rounded-tr-lg flex items-center justify-center">
              <input
                type="number"
                name="lngCode"
                class="border border-gray-300 rounded-lg w-full h-full p-2"
                v-model="optionCd"
                :disabled="!isNewColumn"
                @input="changeOptionManage1" />
            </div>
            <div
              class="border border-black p-2 w-full h-full flex items-center justify-center text-blue-500 font-semibold bg-gray-100">
              *옵션명
            </div>
            <div
              class="border border-black p-2 w-full h-full flex items-center justify-center">
              <input
                type="text"
                class="border border-gray-300 rounded-lg w-full h-full p-2"
                v-model="optionNm"
                name="strName"
                @input="changeOptionManage1"
                :disabled="!clickrowData1" />
            </div>
            <div
              class="border border-black p-2 w-full h-full flex items-center justify-center text-blue-500 font-semibold bg-gray-100">
              *필수/선택
            </div>
            <div
              class="border border-black p-2 w-full h-full flex items-center justify-start">
              <label
                ><input
                  type="radio"
                  name="blnMustSel"
                  v-model="selectedOption"
                  value="1"
                  @input="changeOptionManage1"
                  :disabled="!clickrowData1" />필수</label
              >
              <label
                ><input
                  type="radio"
                  name="blnMustSel"
                  v-model="selectedOption"
                  value="0"
                  @input="changeOptionManage1"
                  :disabled="!clickrowData1" />선택</label
              >
            </div>
            <div
              class="border border-black p-2 w-full h-full rounded-bl-lg flex items-center justify-center text-blue-500 font-semibold bg-gray-100">
              *옵션 선택갯수
            </div>
            <div
              class="border border-black p-2 w-full h-full rounded-br-lg flex items-center justify-center">
              <input
                type="number"
                name="intMultiple"
                class="border border-gray-300 rounded-lg w-full h-full p-2"
                v-model="optionNo"
                @input="changeOptionManage1"
                :disabled="!clickrowData1" />
            </div>
          </div>
          <div class="mt-5 w-full h-[73%]">
            <div class="flex justify-between">
              <span class="font-bold text-xl flex justify-start"
                >옵션 구성</span
              >
              <div class="flex gap-1">
                <button class="whitebutton" @click="addMenus">추가</button
                ><button class="whitebutton" @click="deleteRowData2">
                  삭제</button
                ><button class="whitebutton" @click="deleteAll">초기화</button>
              </div>
            </div>
            <Realgrid
              :progname="'MST01_011INS_01_VUE'"
              :progid="4"
              :rowData="filteredrowData2"
              class="mt-5"
              :dragOn="true"
              @updatedRowData="updatedRowData"
              @selectedIndex2="selectedIndex4"
              :notsoftDelete="true"
              @realgridname="realgridname3"
              :rowStateeditable="false"
              :deleteRow="deleterow3"
              :deleteAll="deleteAll1"
              :initSelect="initSelect"
              :addrowProp="addrowProp2"
              :addRow3="addrow4"></Realgrid>
          </div>
        </div>

        <div
          class="h-full w-1/3 flex flex-col pl-10"
          v-show="currentMenu == true">
          <div
            class="grid grid-cols-[1fr,3fr] grid-rows-3 items-center w-full h-[15%] rounded-lg">
            <div
              class="border border-black p-2 w-full h-full rounded-tl-lg flex items-center justify-center text-blue-500 font-semibold bg-gray-100">
              *옵션그룹코드
            </div>
            <div
              class="border border-black p-2 w-full h-full rounded-tr-lg flex items-center justify-center">
              <input
                type="number"
                class="border border-gray-300 rounded-lg w-full h-full p-2"
                name="lngCode"
                v-model="optionGroupCd"
                :disabled="!isNewColumn2"
                @input="changeOptionManage2" />
            </div>
            <div
              class="border border-black p-2 w-full h-full flex items-center justify-center text-blue-500 font-semibold bg-gray-100 rounded-bl-lg">
              *옵션그룹명
            </div>
            <div
              class="border border-black p-2 w-full h-full flex items-center justify-center rounded-br-lg">
              <input
                type="text"
                name="strName"
                class="border border-gray-300 rounded-lg w-full h-full p-2"
                v-model="optionGroupNm"
                @input="changeOptionManage2"
                :disabled="!clickrowData2" />
            </div>
          </div>
          <div class="mt-11 w-full h-[73%]">
            <div class="flex justify-between">
              <span class="font-bold text-xl flex justify-start"
                >옵션그룹 구성</span
              >
              <div class="flex gap-1">
                <button class="whitebutton" @click="addRowData4">추가</button
                ><button class="whitebutton" @click="deleteRowData4">
                  삭제</button
                ><button class="whitebutton" @click="deleteAlls">초기화</button>
              </div>
            </div>
            <Realgrid
              :progname="'MST01_011INS_01_VUE'"
              :progid="3"
              :rowData="filteredrowData4"
              @updatedRowData="updatedRowData2"
              @realgridname="realgridname4"
              @selectedIndex2="selectedIndex3"
              :rowStateeditable="false"
              :initSelect="initSelect"
              class="mt-5"
              :dragOn="true"
              :notsoftDelete="true"
              :deleteRow="deleterow4"
              :deleteAll="deleteAll2"
              :addRow="addrow2"></Realgrid>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--그리드 영역 및 연동 데이터 영역 -->
</template>

<script setup>
import {
  getAllOptionManageData,
  getAllOptionManageData2_01101,
  getMostColumnMenuList,
  getOptionCompositionList,
  saveOptions,
  saveOptions2,
  saveNewOption1,
  saveNewOption2,
} from "@/api/master";
/*
 * 공통 표준  Function
 */

import { computed, nextTick, onMounted, ref, watch } from "vue";
/**
 *  Vuex 상태관리 및 로그인세션 관련 라이브러리
 */

import { useStore } from "vuex";

/**
 * 매장 공통 컴포넌트
 */

import PickStore from "@/components/pickStore.vue";
/**
 * 	그리드 생성
 */

import Realgrid from "@/components/realgrid.vue";
/**
 *  경고창 호출 라이브러리
 *  */

import Swal from "sweetalert2";
/**
 * 	그리드 생성
 */

/**
 *  리얼그리드 라이브러리 호출
 *  */

import RealGrid from "realgrid";
/**
 *  페이지로그 자동 입력
 *  */

import { insertPageLog } from "@/customFunc/customFunc";
/**
 *  페이지명 자동 입력 컴포넌트
 *  */

import PageName from "@/components/pageName.vue";

const store = useStore();

/**
 * 	화면 Load시 실행 스크립트
 */

onMounted(async () => {
  const pageLog = await insertPageLog(store.state.activeTab2);

  const commonMenuFlag =
    store.state.userData.intCommonMenu ?? store.state.userData.lngCommonMenu;
  if (String(commonMenuFlag) === "1") {
    hidesub.value = false;
    hideAttr.value = false;
  } else {
    hidesub.value = true;
    hideAttr.value = true;
  }
});

// 더미 데이터
const labelData = ref([["필수", "선택"]]);
const valueData = ref([["1", "0"]]);
const currentMenu = ref(false);
const items = ref([]);
const selectedOptionCd = ref();
const ScreenKeyOrigin = ref([]);
const rowData1 = ref([]);
/**
 * 입력창 수정 데이터 갱신
 */
const hidesub = ref(true);
const hideAttr = ref(true);
const updatedRowData4 = ref([]);
const rowData2 = ref([]);
const rowData3 = ref([]);
const filteredrowData2 = ref([]);
const rowData4 = ref([]);
const rowData5 = ref([]);
const rowData6 = ref([]);
const filteredrowData4 = ref([]);
const ScreenKeys = ref();
const initFocus = ref(false);
const searchColValue2 = ref("0,0,0,0");
const forsearchMain = ref("0");
const forsearchSub = ref("0");
/**
 *  그리드 검색어 세팅
 */

const searchword2 = ref();
/**
 *  그리드 검색어 세팅
 */

const searchword4 = ref();
const optionGroupCd = ref("");
const optionGroupNm = ref("");
const selectedOption = ref();
// 드래그 가능한 요소를 설정하는 메서드

const selectedGroupNm = ref();
const selectedStoreNm = ref();
const menuSort = ref(0);
const deliverySort = ref(0);
const subCategory = ref(0);
const mainCategory = ref(0);

const addMenu = ref(false);
const clickedStoreNm = ref();
/**
 * 페이지 매장명 세팅
 */

const handlestoreNm = (newData) => {
  clickedStoreNm.value = newData;
};

const confirmitem = ref([]);
const confirmitem2 = ref([]);
const hasChainOrderChanged = (
  currentRows,
  originalRows,
  chainPrefix,
  chainCount
) => {
  const normalizeRows = (rows = []) =>
    rows
      .filter((item) => item.deleted != true)
      .map((item) => ({
        lngCode: Number(item.lngCode) || 0,
        chain: Array.from({ length: chainCount }, (_, idx) =>
          Number(item[`${chainPrefix}${idx + 1}`]) || 0
        ),
      }))
      .sort((a, b) => a.lngCode - b.lngCode);

  const current = normalizeRows(currentRows);
  const original = normalizeRows(originalRows);

  if (current.length !== original.length) {
    return true;
  }

  return current.some((item, rowIdx) => {
    const target = original[rowIdx];
    if (!target || item.lngCode !== target.lngCode) {
      return true;
    }
    return item.chain.some((value, chainIdx) => value !== target.chain[chainIdx]);
  });
};
const realgridName = ref();
const realgridname = (e) => {
  realgridName.value = e;
};
const realgridName2 = ref();
const realgridname2 = (e) => {
  realgridName2.value = e;
};
const realgridName3 = ref();
const realgridname3 = (e) => {
  realgridName3.value = e;
};
const realgridName4 = ref();
const realgridname4 = (e) => {
  realgridName4.value = e;
};

watch(currentMenu, () => {
  const reagrid2 = document.getElementById(realgridName.value);
  setTimeout(() => {
    RealGrid.getGridInstance(reagrid2).resetSize();
    RealGrid.getGridInstance(reagrid2).refresh(true);
  }, 100);
  const reagrid3 = document.getElementById(realgridName2.value);
  setTimeout(() => {
    RealGrid.getGridInstance(reagrid3).resetSize();
    RealGrid.getGridInstance(reagrid3).refresh(true);
  }, 100);
  const reagrid4 = document.getElementById(realgridName3.value);
  setTimeout(() => {
    RealGrid.getGridInstance(reagrid4).resetSize();
    RealGrid.getGridInstance(reagrid4).refresh(true);
  }, 100);
  const reagrid5 = document.getElementById(realgridName4.value);
  setTimeout(() => {
    RealGrid.getGridInstance(reagrid5).resetSize();
    RealGrid.getGridInstance(reagrid5).refresh(true);
  }, 100);
});

/**
 * 선택한 포스 번호 호출 함수
 */

const posNo = ref();

const AllscreenKeyPage = ref(1);

watch(selectedOption, () => {
  //comsole.log(selectedOption.value);
});

const selectMenuGroup = ref(false);
let dupliitems = [];

const nowStoreAreaCd = ref();
/**
 *  pickStore - 지역코드 세팅
 */

const handleStoreAreaCd = (newValue) => {
  nowStoreAreaCd.value = newValue;
  //comsole.log(nowStoreAreaCd.value);
};

const nowStoreCd = ref(0);
const pickedStoreCd = ref("");
const dataScope = ref("COMMON");
const scopeStoreCd = ref("");
const isStoreScopeFeatureEnabled = computed(() => {
  const commonMenuFlag =
    store.state.userData.intCommonMenu ?? store.state.userData.lngCommonMenu;
  return String(commonMenuFlag) === "1";
});
const scopeStoreOptions = computed(() =>
  (store.state.storeCd || []).filter((item) => item?.lngStoreCode != null)
);
const normalizeScopeStoreCd = (value) => {
  const strValue = value != null ? String(value) : "";
  if (!strValue || strValue === "-1" || strValue === "0") {
    return "";
  }
  return strValue;
};
const getEffectiveStoreCd = () => {
  if (!isStoreScopeFeatureEnabled.value || dataScope.value !== "STORE") {
    return nowStoreCd.value;
  }
  const selected = normalizeScopeStoreCd(scopeStoreCd.value || pickedStoreCd.value);
  return selected || nowStoreCd.value;
};
watch(dataScope, (newValue) => {
  if (newValue !== "STORE") {
    // 공통(그룹) 전환 시 저장 매장을 "선택" 상태로 초기화
    scopeStoreCd.value = "";
  }
});
const afterCategory = ref(false);
/**
 * 페이지 매장 코드 세팅
 */

const handleStoreCd = async (newValue) => {
  pickedStoreCd.value = String(newValue);
  if (!scopeStoreCd.value || scopeStoreCd.value == "-1") {
    scopeStoreCd.value = normalizeScopeStoreCd(newValue);
  }
  if (newValue == "0") {
    afterSearch.value = false;
  }

  if (isStoreScopeFeatureEnabled.value) {
    nowStoreCd.value = 0;
  } else {
    nowStoreCd.value = newValue;
  }

  //  nowStoreCd.value = newValue;
};
const selectedButton = ref();
const Category = ref([]);
const searchWord4 = (e) => {
  searchword4.value = e.target.value;
};
const MenuGroup = ref([]);
const SubMenuGroup = ref([]);

/**
 *  그리드 검색어 세팅
 */

const searchword1 = ref();
/**
 *  그리드 검색어 세팅
 */

const searchword3 = ref();
const userData = store.state.userData;
const groupCd = ref(userData.lngStoreGroup);
const modified = ref(false);
const afterSearch = ref(false);
const MenuList = ref([]);
const MenuKeyList = ref([]);
const clickedScreenOrMenu = ref(false);
const TLUList = ref([]);
const optionCd = ref();
const optionNm = ref();
const optionNo = ref();
const addrowProp = ref(
  "lngCode,strName,blnMustSel,intMultiple,lngChainMenu1,lngChainMenu2,lngChainMenu3,lngChainMenu4,lngChainMenu5,lngChainMenu6,lngChainMenu7,lngChainMenu8,lngChainMenu9,lngChainMenu10,lngChainMenu11,lngChainMenu12,lngChainMenu13,lngChainMenu14,lngChainMenu15,lngChainMenu16,lngChainMenu17,lngChainMenu18,lngChainMenu19,lngChainMenu20,lngChainMenu21"
);
const addrowProp2 = ref(
  "lngCode,strName,lngChainGroup1,lngChainGroup2,lngChainGroup3,lngChainGroup4,lngChainGroup5,lngChainGroup6,lngChainGroup7,lngChainGroup8,lngChainGroup9,lngChainGroup10,lngChainGroup11,lngChainGroup12,lngChainGroup13,lngChainGroup14,lngChainGroup15,lngChainGroup16,lngChainGroup17,lngChainGroup18,lngChainGroup19,lngChainGroup20"
);

const showMenus = (newValue) => {
  if (newValue == 1) {
    currentMenu.value = false;
  } else if (newValue == 2) {
    currentMenu.value = true;
  }
};

const initSelect = ref(false);
const isNewColumn = ref(false);
const isNewColumn2 = ref(false);
const clickrowData1 = ref(false);
/**
 * 데이터셋 상세정보 셋팅
 */

const clickedRowData = (newValue) => {
  if (isNewColumn.value == true) {
  } else {
  }
  clickrowData1.value = true;
  // console.log(newValue);
  if (newValue == undefined) {
    return;
  }
  selectedOptionCd.value = Number(newValue[0]);
  if (currState.value == "created") {
    isNewColumn.value = true;
  } else {
    isNewColumn.value = false;
  }
  // isNewColumn.value = newValue[26] == true ? true : false;
  filteredrowData2.value = [];
  for (var i = 0; i < 21; i++) {
    if (newValue[4 + i] != "0") {
      const seleced = rowData2.value.find(
        (item) => item.lngCode == Number(newValue[4 + i])
      );
      if (seleced != undefined) {
        filteredrowData2.value.push({
          lngCode: seleced.lngCode,
          strName: seleced.strName,
          lngPrice: seleced.lngPrice,
        });
      }

      //comsole.log(filteredrowData2.value);
    }
  }
  selectedOption.value = newValue[2];
  optionCd.value = Number(newValue[0]);
  optionNm.value = newValue[1];
  optionNo.value = newValue[3];
};
const selectedOptionGroupCd = ref();
const clickrowData2 = ref(false);
/**
 * 데이터셋 상세정보 셋팅
 */

const clickedRowData2 = (newValue) => {
  //comsole.log(newValue);
  if (newValue == undefined) {
    return;
  }
  clickrowData2.value = true;
  selectedOptionGroupCd.value = newValue[0];
  if (currState2.value == "created") {
    isNewColumn2.value = true;
  } else {
    isNewColumn2.value = false;
  }
  //isNewColumn2.value = newValue[23] == true ? true : false;
  filteredrowData4.value = [];
  for (var i = 0; i < 20; i++) {
    if (newValue[2 + i] != "0") {
      //comsole.log(rowData4.value);
      const seleced = rowData4.value.find(
        (item) => item.lngCode == Number(newValue[2 + i])
      );
      if (seleced != undefined) {
        filteredrowData4.value.push({
          lngCode: seleced.lngCode,
          strName: seleced.strName,
        });
      }
      //comsole.log(filteredrowData4.value);
    }
  }
  optionGroupCd.value = newValue[0];
  optionGroupNm.value = newValue[1];
};
const selectedaddMenu = ref();
const selectedaddMenu2 = ref();
/**
 * 데이터셋 상세정보 셋팅
 */

const clickedRowData3 = (newValue) => {
  selectedaddMenu.value = newValue;
};
/**
 * 데이터셋 상세정보 셋팅
 */

const clickedRowData4 = (newValue) => {
  selectedaddMenu2.value = newValue;
};
/**
 * 데이터셋 상세정보 셋팅
 */

const clickedRowData5 = (newValue) => {
  //comsole.log(newValue);
};
const searchWord3 = (e) => {
  searchword3.value = e.target.value;
};

watch(rowData3, () => {
  //comsole.log(rowData3.value);
});
/**
 *  조회 함수
 */

const searchButton = async () => {
  filteredrowData2.value = [];
  rowData1.value = [];
  rowData2.value = [];
  rowData3.value = [];
  rowData4.value = [];

  const effectiveStoreCd = getEffectiveStoreCd();
  if (
    isStoreScopeFeatureEnabled.value &&
    dataScope.value === "STORE" &&
    (!effectiveStoreCd || effectiveStoreCd === "0")
  ) {
    Swal.fire({
      title: "경고",
      text: "매장별 조회 시 저장 매장을 선택하세요.",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      allowOutsideClick: false,
    });
    return;
  }

  const commonMenuFlag =
    store.state.userData.intCommonMenu ?? store.state.userData.lngCommonMenu;
  if (nowStoreCd.value == "0" && String(commonMenuFlag) === "0") {
    Swal.fire({
      title: "경고",
      text: "매장을 선택하세요.",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      allowOutsideClick: false,
    });
    return;
  }

  store.state.loading = true;
  try {
    optionNo.value = "";
    selectedOption.value = "";
    optionNm.value = "";
    optionCd.value = "";
    optionGroupNm.value = "";
    optionGroupCd.value = "";

    filteredrowData2.value = [];
    filteredrowData4.value = [];

    const menuListStoreCd = isStoreScopeFeatureEnabled.value
      ? 0
      : nowStoreCd.value;

    // console.log(menuListStoreCd);

    let res3;
    let res4;
    let res5;
    if (isStoreScopeFeatureEnabled.value && dataScope.value === "STORE") {
      res3 = await getAllOptionManageData2_01101(groupCd.value, effectiveStoreCd);
    } else {
      res3 = await getAllOptionManageData(groupCd.value, effectiveStoreCd);
    }
    
    res5 = await getOptionCompositionList(groupCd.value, menuListStoreCd);
    res4 = await getMostColumnMenuList(groupCd.value,menuListStoreCd);
    
    // console.log(res5);

    rowData1.value = res3.data.OPTIONMANAGE;
    rowData2.value = res5.data.MENULIST;
    rowData3.value = res3.data.OPTIONGROUPMANAGE;
    rowData4.value = res3.data.OPTIONGROUPCOMPOSITION;
    rowData6.value = res3.data.OPTIONMANAGE;
    rowData5.value = res4.data.MENULIST;
    MenuGroup.value = res4.data.MAINGROUP;
    SubMenuGroup.value = res4.data.SUBGROUP;
    afterSearch.value = true;
    confirmitem.value = JSON.parse(JSON.stringify(rowData1.value));
    updatedRowData4.value = JSON.parse(JSON.stringify(rowData1.value));
    confirmitem2.value = JSON.parse(JSON.stringify(rowData3.value));
    updatedRowData5.value = JSON.parse(JSON.stringify(rowData3.value));
  } catch (error) {
    afterSearch.value = false;
  } finally {
    initFocus.value = !initFocus.value;
    store.state.loading = false; // 로딩 상태 종료
    modified.value = false;
    initSelect.value = !initSelect.value;
    afterCategory.value = false;
    clickrowData1.value = false;
  }
};
const filteredSubMenuGroup = ref([]);

watch(mainCategory, () => {
  filteredSubMenuGroup.value = SubMenuGroup.value.filter(
    (item) => item.lngMajor == mainCategory.value
  );
  subCategory.value = 0;
});

/**
 *  저장 버튼 함수
 */

const saveButton = async () => {
  const effectiveStoreCd = getEffectiveStoreCd();
  if (
    isStoreScopeFeatureEnabled.value &&
    dataScope.value === "STORE" &&
    (!effectiveStoreCd || effectiveStoreCd === "0")
  ) {
    Swal.fire({
      title: "경고",
      text: "매장별 저장 시 저장 매장을 선택하세요.",
      icon: "warning",
      confirmButtonText: "확인",
    });
    return;
  }

  if (afterSearch.value == false) {
    Swal.fire({
      title: "경고",
      text: "조회를 먼저 진행해주세요.",
      icon: "warning",
      confirmButtonText: "확인",
    });
    return;
  }
  const hasOptionCompositionChanged = hasChainOrderChanged(
    updatedRowData4.value,
    confirmitem.value,
    "lngChainMenu",
    21
  );
  const hasOptionGroupCompositionChanged = hasChainOrderChanged(
    updatedRowData5.value,
    confirmitem2.value,
    "lngChainGroup",
    20
  );
  if (currentMenu.value == false) {
    if (
      allstaterows.value.deleted.length == 0 &&
      allstaterows.value.created.length == 0 &&
      allstaterows.value.updated.length == 0 &&
      !hasOptionCompositionChanged
    ) {
      Swal.fire({
        title: "경고",
        text: "변경된 사항이 없습니다.",
        icon: "warning",
        confirmButtonText: "확인",
      });
      return;
    }
  } else {
    if (
      allstaterows2.value.deleted.length == 0 &&
      allstaterows2.value.created.length == 0 &&
      allstaterows2.value.updated.length == 0 &&
      !hasOptionGroupCompositionChanged
    ) {
      Swal.fire({
        title: "경고",
        text: "변경된 사항이 없습니다.",
        icon: "warning",
        confirmButtonText: "확인",
      });
      return;
    }
  }

  const undefinededrowlength = updatedRowData4.value
    .filter((item) => item.deleted != true)
    .filter(
      (item) =>
        item.lngCode == "" ||
        item.lngCode == undefined ||
        item.strName == undefined ||
        item.strName == "" ||
        item.intMultiple == undefined ||
        item.intMultiple == "" ||
        item.blnMustSel == undefined ||
        item.blnMustSel == ""
    ).length;
  const undefinededrow2length = updatedRowData5.value
    .filter((item) => item.deleted != true)
    .filter(
      (item) =>
        item.lngCode == "" ||
        item.lngCode == undefined ||
        item.strName == undefined ||
        item.strName == ""
    ).length;

  if (currentMenu.value == false) {
    if (undefinededrowlength > 0) {
      Swal.fire({
        title: "경고",
        text: "옵션 정보에 빈 값이 존재합니다",
        icon: "warning",
        confirmButtonText: "확인",
      });
      currentMenu.value = false;
      return;
    }
  } else {
    if (undefinededrow2length > 0) {
      Swal.fire({
        title: "경고",
        text: "옵션 그룹 정보에 빈 값이 존재합니다",
        icon: "warning",
        confirmButtonText: "확인",
      });
      currentMenu.value = true;
      return;
    }
  }

  Swal.fire({
    title: "저장",
    text: "저장 하시겠습니까?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "저장",
    cancelButtonText: "취소",
  }).then(async (result) => {
    if (result.isConfirmed) {
      store.state.loading = true;
      try {

        if (currentMenu.value == false) {
          // 1. 먼저 삭제되지 않은 데이터를 필터링
          const filteredData = updatedRowData4.value
            .filter((_, index) => !allstaterows.value.deleted.includes(index));
          
          // 디버깅: 필터링 전 원본 데이터 확인
          // console.log("필터링 전 updatedRowData4:", updatedRowData4.value.map(item => ({ lngCode: item.lngCode, strName: item.strName })));
          // console.log("필터링 후 filteredData:", filteredData.map(item => ({ lngCode: item.lngCode, strName: item.strName })));
          
          // 2. lngCode 기준으로 정렬 (복사본 생성 후 정렬하여 원본 보호)
          const sortedData = [...filteredData].sort((a, b) => {
            const codeA = parseInt(a.lngCode) || 0;
            const codeB = parseInt(b.lngCode) || 0;
            return codeA - codeB;
          });
          
          // 디버깅: 정렬 후 데이터 확인
          // console.log("정렬 후 sortedData:", sortedData.map(item => ({ lngCode: item.lngCode, strName: item.strName })));

          // 3. 정렬된 데이터에서 각 필드 추출 (같은 객체에서 추출하여 매핑 보장)
          const lngCodes = sortedData.map((item) => item.lngCode);
          const strNames = sortedData.map((item) => item.strName.replace(/,/g, '/')); // 쉼표를 | 로 변경
          const blnMustSels = sortedData.map((item) => item.blnMustSel);
          const intMultiples = sortedData.map((item) => item.intMultiple);
          
          // 디버깅: 추출된 데이터 확인
          // console.log("추출된 lngCodes:", lngCodes);
          // console.log("추출된 strNames:", strNames);
          // console.log("매핑 확인:", lngCodes.map((code, idx) => ({ lngCode: code, strName: strNames[idx] })));
          const lngChainMenu1 = sortedData.map((item) => item.lngChainMenu1);
          const lngChainMenu2 = sortedData.map((item) => item.lngChainMenu2);
          const lngChainMenu3 = sortedData.map((item) => item.lngChainMenu3);
          const lngChainMenu4 = sortedData.map((item) => item.lngChainMenu4);
          const lngChainMenu5 = sortedData.map((item) => item.lngChainMenu5);
          const lngChainMenu6 = sortedData.map((item) => item.lngChainMenu6);
          const lngChainMenu7 = sortedData.map((item) => item.lngChainMenu7);
          const lngChainMenu8 = sortedData.map((item) => item.lngChainMenu8);
          const lngChainMenu9 = sortedData.map((item) => item.lngChainMenu9);
          const lngChainMenu10 = sortedData.map((item) => item.lngChainMenu10);
          const lngChainMenu11 = sortedData.map((item) => item.lngChainMenu11);
          const lngChainMenu12 = sortedData.map((item) => item.lngChainMenu12);
          const lngChainMenu13 = sortedData.map((item) => item.lngChainMenu13);
          const lngChainMenu14 = sortedData.map((item) => item.lngChainMenu14);
          const lngChainMenu15 = sortedData.map((item) => item.lngChainMenu15);
          const lngChainMenu16 = sortedData.map((item) => item.lngChainMenu16);
          const lngChainMenu17 = sortedData.map((item) => item.lngChainMenu17);
          const lngChainMenu18 = sortedData.map((item) => item.lngChainMenu18);
          const lngChainMenu19 = sortedData.map((item) => item.lngChainMenu19);
          const lngChainMenu20 = sortedData.map((item) => item.lngChainMenu20);
          const lngChainMenu21 = sortedData.map((item) => item.lngChainMenu21);

          // 백엔드로 전송되는 데이터 확인
          // console.log("=== 백엔드 전송 데이터 ===");
          // console.log("sortedData 전체:", sortedData); // 이거 추가!
          // console.log("lngCodes (join):", lngCodes.join(","));
          // console.log("strNames (join):", strNames.join(","));
          // console.log("전송 전 최종 매핑 확인:", lngCodes.map((code, idx) => ({ 
          //   index: idx, 
          //   lngCode: code, 
          //   strName: strNames[idx] 
          // })));

          const saveOptionsApi =
            isStoreScopeFeatureEnabled.value && dataScope.value === "STORE"
              ? saveNewOption1
              : saveOptions;
          const res = await saveOptionsApi(
            groupCd.value,
            effectiveStoreCd,
            lngCodes.join(","),
            strNames.join(","),
            blnMustSels.join(","),
            intMultiples.join(","),
            lngChainMenu1.join(","),
            lngChainMenu2.join(","),
            lngChainMenu3.join(","),
            lngChainMenu4.join(","),
            lngChainMenu5.join(","),
            lngChainMenu6.join(","),
            lngChainMenu7.join(","),
            lngChainMenu8.join(","),
            lngChainMenu9.join(","),
            lngChainMenu10.join(","),
            lngChainMenu11.join(","),
            lngChainMenu12.join(","),
            lngChainMenu13.join(","),
            lngChainMenu14.join(","),
            lngChainMenu15.join(","),
            lngChainMenu16.join(","),
            lngChainMenu17.join(","),
            lngChainMenu18.join(","),
            lngChainMenu19.join(","),
            lngChainMenu20.join(","),
            lngChainMenu21.join(",")
          );

          // console.log(res);

        } else {
          // 1. 삭제되지 않은 데이터 필터링
          const filteredData2 = updatedRowData5.value
            .filter((_, index) => !allstaterows2.value.deleted.includes(index));

          // 2. lngCode 기준으로 정렬 (복사본 생성 후 정렬하여 원본 보호)
          const sortedData2 = [...filteredData2].sort((a, b) => {
            const codeA = parseInt(a.lngCode) || 0;
            const codeB = parseInt(b.lngCode) || 0;
            return codeA - codeB;
          });

          // 3. 정렬된 데이터에서 각 필드 추출
          const lngCodes2 = sortedData2.map((item) => item.lngCode);
          const strNames2 = sortedData2.map((item) => item.strName.replace(/,/g, '/'));
          const lngChainGroup1 = sortedData2.map((item) => item.lngChainGroup1);
          const lngChainGroup2 = sortedData2.map((item) => item.lngChainGroup2);
          const lngChainGroup3 = sortedData2.map((item) => item.lngChainGroup3);
          const lngChainGroup4 = sortedData2.map((item) => item.lngChainGroup4);
          const lngChainGroup5 = sortedData2.map((item) => item.lngChainGroup5);
          const lngChainGroup6 = sortedData2.map((item) => item.lngChainGroup6);
          const lngChainGroup7 = sortedData2.map((item) => item.lngChainGroup7);
          const lngChainGroup8 = sortedData2.map((item) => item.lngChainGroup8);
          const lngChainGroup9 = sortedData2.map((item) => item.lngChainGroup9);
          const lngChainGroup10 = sortedData2.map((item) => item.lngChainGroup10);
          const lngChainGroup11 = sortedData2.map((item) => item.lngChainGroup11);
          const lngChainGroup12 = sortedData2.map((item) => item.lngChainGroup12);
          const lngChainGroup13 = sortedData2.map((item) => item.lngChainGroup13);
          const lngChainGroup14 = sortedData2.map((item) => item.lngChainGroup14);
          const lngChainGroup15 = sortedData2.map((item) => item.lngChainGroup15);
          const lngChainGroup16 = sortedData2.map((item) => item.lngChainGroup16);
          const lngChainGroup17 = sortedData2.map((item) => item.lngChainGroup17);
          const lngChainGroup18 = sortedData2.map((item) => item.lngChainGroup18);
          const lngChainGroup19 = sortedData2.map((item) => item.lngChainGroup19);
          const lngChainGroup20 = sortedData2.map((item) => item.lngChainGroup20);

          const saveOptions2Api =
            isStoreScopeFeatureEnabled.value && dataScope.value === "STORE"
              ? saveNewOption2
              : saveOptions2;
          const res = await saveOptions2Api(
            groupCd.value,
            effectiveStoreCd,
            lngCodes2.join(","),
            strNames2.join(","),
            lngChainGroup1.join(","),
            lngChainGroup2.join(","),
            lngChainGroup3.join(","),
            lngChainGroup4.join(","),
            lngChainGroup5.join(","),
            lngChainGroup6.join(","),
            lngChainGroup7.join(","),
            lngChainGroup8.join(","),
            lngChainGroup9.join(","),
            lngChainGroup10.join(","),
            lngChainGroup11.join(","),
            lngChainGroup12.join(","),
            lngChainGroup13.join(","),
            lngChainGroup14.join(","),
            lngChainGroup15.join(","),
            lngChainGroup16.join(","),
            lngChainGroup17.join(","),
            lngChainGroup18.join(","),
            lngChainGroup19.join(","),
            lngChainGroup20.join(",")
          );
        }
      } catch (error) {
        // console.log(error);
      } finally {
        store.state.loading = false;
        Swal.fire({
          title: "저장 되었습니다.",
          confirmButtonText: "확인",
        });

        searchButton();
      }
    }
  });
};

/**
 * 입력창 수정 데이터 갱신
 */

const updatedRowData3 = (e) => {
  // console.log(e);
  updatedRowData4.value = e;
};

/**
 * 입력창 수정 데이터 갱신
 */

const updatedRowData5 = ref([]);

/**
 * 입력창 수정 데이터 갱신
 */

const updatedRowData6 = (e) => {
  updatedRowData5.value = e;
};
/**
 * 입력창 수정 데이터 갱신
 */

const updatedRowData = (newValue) => {
  //comsole.log(optionCd.value);
  filteredrowData2.value = newValue;
  const change = updatedRowData4.value.find(
    (item) => item.lngCode == Number(optionCd.value)
  );

  if (change) {
    change.lngChainMenu1 = newValue[0] == undefined ? 0 : newValue[0].lngCode;
    change.lngChainMenu2 = newValue[1] == undefined ? 0 : newValue[1].lngCode;
    change.lngChainMenu3 = newValue[2] == undefined ? 0 : newValue[2].lngCode;
    change.lngChainMenu4 = newValue[3] == undefined ? 0 : newValue[3].lngCode;
    change.lngChainMenu5 = newValue[4] == undefined ? 0 : newValue[4].lngCode;
    change.lngChainMenu6 = newValue[5] == undefined ? 0 : newValue[5].lngCode;
    change.lngChainMenu7 = newValue[6] == undefined ? 0 : newValue[6].lngCode;
    change.lngChainMenu8 = newValue[7] == undefined ? 0 : newValue[7].lngCode;
    change.lngChainMenu9 = newValue[8] == undefined ? 0 : newValue[8].lngCode;
    change.lngChainMenu10 = newValue[9] == undefined ? 0 : newValue[9].lngCode;
    change.lngChainMenu11 =
      newValue[10] == undefined ? 0 : newValue[10].lngCode;
    change.lngChainMenu12 =
      newValue[11] == undefined ? 0 : newValue[11].lngCode;
    change.lngChainMenu13 =
      newValue[12] == undefined ? 0 : newValue[12].lngCode;
    change.lngChainMenu14 =
      newValue[13] == undefined ? 0 : newValue[13].lngCode;
    change.lngChainMenu15 =
      newValue[14] == undefined ? 0 : newValue[14].lngCode;
    change.lngChainMenu16 =
      newValue[15] == undefined ? 0 : newValue[15].lngCode;
    change.lngChainMenu17 =
      newValue[16] == undefined ? 0 : newValue[16].lngCode;
    change.lngChainMenu18 =
      newValue[17] == undefined ? 0 : newValue[17].lngCode;
    change.lngChainMenu19 =
      newValue[18] == undefined ? 0 : newValue[18].lngCode;
    change.lngChainMenu20 =
      newValue[19] == undefined ? 0 : newValue[19].lngCode;
    change.lngChainMenu21 =
      newValue[20] == undefined ? 0 : newValue[20].lngCode;
  }
};

/**
 * 입력창 수정 데이터 갱신
 */

const updatedRowData2 = (newValue) => {
  ////console.log(newValue);
  filteredrowData4.value = newValue;
  const change = updatedRowData5.value.find(
    (item) => item.lngCode == Number(selectedOptionGroupCd.value)
  );
  if (change) {
    change.lngChainGroup1 = newValue[0] == undefined ? 0 : newValue[0].lngCode;
    change.lngChainGroup2 = newValue[1] == undefined ? 0 : newValue[1].lngCode;
    change.lngChainGroup3 = newValue[2] == undefined ? 0 : newValue[2].lngCode;
    change.lngChainGroup4 = newValue[3] == undefined ? 0 : newValue[3].lngCode;
    change.lngChainGroup5 = newValue[4] == undefined ? 0 : newValue[4].lngCode;
    change.lngChainGroup6 = newValue[5] == undefined ? 0 : newValue[5].lngCode;
    change.lngChainGroup7 = newValue[6] == undefined ? 0 : newValue[6].lngCode;
    change.lngChainGroup8 = newValue[7] == undefined ? 0 : newValue[7].lngCode;
    change.lngChainGroup9 = newValue[8] == undefined ? 0 : newValue[8].lngCode;
    change.lngChainGroup10 = newValue[9] == undefined ? 0 : newValue[9].lngCode;
    change.lngChainGroup11 =
      newValue[10] == undefined ? 0 : newValue[10].lngCode;
    change.lngChainGroup12 =
      newValue[11] == undefined ? 0 : newValue[11].lngCode;
    change.lngChainGroup13 =
      newValue[12] == undefined ? 0 : newValue[12].lngCode;
    change.lngChainGroup14 =
      newValue[13] == undefined ? 0 : newValue[13].lngCode;
    change.lngChainGroup15 =
      newValue[14] == undefined ? 0 : newValue[14].lngCode;
    change.lngChainGroup16 =
      newValue[15] == undefined ? 0 : newValue[15].lngCode;
    change.lngChainGroup17 =
      newValue[16] == undefined ? 0 : newValue[16].lngCode;
    change.lngChainGroup18 =
      newValue[17] == undefined ? 0 : newValue[17].lngCode;
    change.lngChainGroup19 =
      newValue[18] == undefined ? 0 : newValue[18].lngCode;
    change.lngChainGroup20 =
      newValue[19] == undefined ? 0 : newValue[19].lngCode;
  }
};

const changeColid = ref("");
const changeValue = ref("");
const changeValue2 = ref("");
const changeRow = ref(0);
const changeNow = ref(false);
const changeNow2 = ref(false);
const changeNow4 = ref(false);
const changeOptionManage1 = (e) => {
  changeColid.value = e.target.name;
  changeValue.value = e.target.value;

  changeNow.value = !changeNow.value;
};
const changeOptionManage2 = (e) => {
  changeColid.value = e.target.name;
  changeValue2.value = e.target.value;

  changeNow2.value = !changeNow2.value;
};

// const changeOptionManage3 = (e) => {
//   const confirmdata = e.target.value.replace(/[^0-9]/g, "");
//   const change = rowData1.value.find(
//     (item, index) => index == selectedindex.value
//   );

//   if (change) {
//     change.intMultiple = confirmdata;
//   }
//   rowData1.value = [...rowData1.value];
// };
// const changeOptionManage4 = (e) => {
//   //comsole.log(rowData1.value);
//   const confirmdata = e.target.value.replace(/[^0-9]/g, "");
//   const duplicate = rowData1.value.find((item) => item.lngCode == confirmdata);
//   if (duplicate) {
//     Swal.fire({
//       title: "중복된 옵션코드",
//       text: "이미 존재하는 코드입니다.",
//       icon: "error",
//       confirmButtonText: "확인",
//     });
//     optionCd.value = "";
//     return;
//   }
//   const change = rowData1.value.find(
//     (item, index) => index == selectedindex.value
//   );
//   if (change) {
//     change.lngCode = confirmdata;
//   }
//   rowData1.value = [...rowData1.value];
//   // optionCd.value = e.target.value
//   // //comsole.log(optionCd.value)
// };

const searchOption = (e) => {
  searchword1.value = e.target.value;
};
const searchOption2 = (e) => {
  searchword2.value = e.target.value;
};
const deleteAll1 = ref(false);
const deleteAll = async () => {
  changeColid.value = "lngChainMenu1";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu2";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu3";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu4";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu5";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu6";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu7";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu8";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu9";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu10";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu11";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu12";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu13";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu14";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu15";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();
  changeColid.value = "lngChainMenu16";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu17";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu18";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu19";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu20";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();

  changeColid.value = "lngChainMenu21";
  changeValue.value = 0;
  changeNow3.value = !changeNow3.value;

  await nextTick();
};
const deleteAll2 = ref(false);
const deleteAlls = async () => {
  changeColid.value = "lngChainGroup1";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup2";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup3";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup4";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup5";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup6";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup7";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup8";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup9";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup10";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup11";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup12";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup13";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup14";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup15";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup16";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup17";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();
  changeColid.value = "lngChainGroup18";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup19";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();

  changeColid.value = "lngChainGroup20";
  changeValue.value = 0;
  changeNow4.value = !changeNow4.value;

  await nextTick();
};
// const updateOptionNm = (e) => {
//   const confirmdata = e.target.value;
//   const change = rowData3.value.find(
//     (item, index) => index == selectedindex2.value
//   );
//   if (change) {
//     change.strName = confirmdata;
//   }
//   rowData3.value = [...rowData3.value];
// };
// const changeOptionGroupCd = (e) => {
//   const Nm = e.target.value;
//   const dupli = rowData3.value.find((item) => item.lngCode == Nm);
//   if (dupli) {
//     Swal.fire({
//       title: "중복된 옵션 그룹코드",
//       text: "이미 존재하는 코드입니다.",
//       icon: "error",
//       confirmButtonText: "확인",
//     });
//     optionGroupCd.value = "";
//     return;
//   }
//   const change = rowData3.value.find(
//     (item, index) => index == selectedindex2.value
//   );
//   if (change) {
//     change.lngCode = Nm;
//   }
//   rowData3.value = [...rowData3.value];
// };
const addrow1 = ref(false);
const addrow2 = ref(false);
const addrow3 = ref(false);
const addrow4 = ref(false);
const deleterow1 = ref(false);
const deleterow2 = ref(false);
const deleterow3 = ref(false);
const deleterow4 = ref(false);

/**
 * 추가 버튼 함수
 */

const addRowData1 = () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "조회를 먼저 해주세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  isNewColumn.value = true;
  optionNo.value = "";
  selectedOption.value = "";
  optionNm.value = "";
  optionCd.value = "";
  filteredrowData2.value = [];
  clickrowData1.value = true;
  addrow1.value = !addrow1.value;
};

/**
 * 추가 버튼 함수
 */

const addRowData3 = () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "조회를 먼저 해주세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  optionGroupNm.value = "";
  optionGroupCd.value = "";
  filteredrowData4.value = [];
  isNewColumn2.value = true;
  clickrowData2.value = true;
  addrow3.value = !addrow3.value;
};
/**
 * 추가 버튼 함수
 */

const addRowData4 = () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "조회를 먼저 해주세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  if (optionGroupCd.value == "" || optionGroupCd.value == undefined) {
    Swal.fire({
      title: "옵션그룹코드를 먼저 선택하세요.",
      confirmButtonText: "확인",
    });
    return;
  }

  selectMenuGroup.value = true;
};
/**
 * 그리드 행 삭제 버튼 함수
 */

const deleteRowData1 = () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "조회를 먼저 해주세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  deleterow1.value = !deleterow1.value;
};
/**
 * 그리드 행 삭제 버튼 함수
 */

const deleteRowData3 = () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "조회를 먼저 해주세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  deleterow2.value = !deleterow2.value;
};
/**
 * 그리드 행 삭제 버튼 함수
 */

const deleteRowData2 = async () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "조회를 먼저 해주세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  ////console.log(filteredrowData2.value);

  const updateLngCode = filteredrowData2.value
    .filter((item, index) => index != changeRow2.value)
    .map((item) => item.lngCode);

  for (let i = 0; i < updateLngCode.length; i++) {
    changeColid.value = "lngChainMenu" + (i + 1);
    changeValue.value = updateLngCode[i];
    changeNow3.value = !changeNow3.value;
    await nextTick();
  }
  for (let j = 0; j < 21 - updateLngCode.length; j++) {
    changeColid.value = "lngChainMenu" + (21 - j);
    changeValue.value = 0;
    changeNow3.value = !changeNow3.value;
    await nextTick();
  }

  //changeNow
  //deleterow3.value = !deleterow3.value;
};
/**
 * 그리드 행 삭제 버튼 함수
 */

const deleteRowData4 = async () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "조회를 먼저 해주세요.",
      confirmButtonText: "확인",
    });
    return;
  }

  ////console.log(filteredrowData4.value);
  const updateLngCode = filteredrowData4.value
    .filter((item, index) => index != changeRow3.value)
    .map((item) => item.lngCode);

  for (let i = 0; i < updateLngCode.length; i++) {
    changeColid.value = "lngChainGroup" + (i + 1);
    changeValue2.value = updateLngCode[i];
    changeNow4.value = !changeNow4.value;
    await nextTick();
  }
  for (let j = 0; j < 20 - updateLngCode.length; j++) {
    changeColid.value = "lngChainGroup" + (20 - j);
    changeValue2.value = 0;
    changeNow4.value = !changeNow4.value;
    await nextTick();
  }
};

const addMenus = () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "조회를 먼저 해주세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  if (optionCd.value == "" || optionCd.value == undefined) {
    Swal.fire({
      title: "옵션을 먼저 선택하세요.",
      confirmButtonText: "확인",
    });
    return;
  }

  addMenu.value = true;
};
const closeMenus = () => {
  subCategory.value = 0;
  mainCategory.value = 0;
  deliverySort.value = 0;
  menuSort.value = 0;
  searchword3.value = "";
  addMenu.value = false;
};
const closeMenus2 = () => {
  selectMenuGroup.value = false;
};
/**
 * 페이지 매장 그룹 이름 세팅
 */

const handleGroupNm = (newValue) => {
  selectedGroupNm.value = newValue;
  //comsole.log(selectedGroupNm.value);
};
/**
 * 페이지 매장 그룹 세팅
 */

const handleGroupCd = (newValue) => {
  groupCd.value = newValue;
};
watch(
  () => [
    menuSort.value,
    deliverySort.value,
    mainCategory.value,
    subCategory.value,
  ], // 감시 대상
  ([newMenuSort, newDeliverySort, newMainCategory, newSubCategory]) => {
    // 값이 변경될 때 실행될 로직
    searchColValue2.value =
      newMenuSort +
      "," +
      newDeliverySort +
      "," +
      newMainCategory +
      "," +
      newSubCategory;
  }
);

const clickaddMenu1 = (newValue) => {
  if (newValue == undefined || newValue == "") {
    Swal.fire({
      title: "메뉴를 선택하세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  subCategory.value = 0;
  mainCategory.value = 0;
  deliverySort.value = 0;
  menuSort.value = 0;
  searchword3.value = "";
  dblclickedRowData(newValue);
};
const clickaddMenu2 = (newValue) => {
  if (newValue == undefined || newValue == "") {
    Swal.fire({
      title: "메뉴그룹을 선택하세요.",
      confirmButtonText: "확인",
    });
    return;
  }
  dblclickedRowData2(newValue);
};
/**
 * 행 더블 클릭시 작동 함수
 */

const changeNow3 = ref(false);

/** 메뉴 조회 팝업: 클릭은 getRows(배열), 더블클릭은 getJsonRow(객체)로 올 수 있음 */
const menuLngCodeFromPopupRow = (row) => {
  if (row == null) return undefined;
  if (Array.isArray(row) && row.length > 2) return row[2];
  if (typeof row === "object" && row.lngCode != null && row.lngCode !== "")
    return row.lngCode;
  return undefined;
};

const isEmptyLngChainMenuSlot = (v) => {
  if (v === undefined || v === null || v === "") return true;
  if (v === "0" || v === 0) return true;
  const n = Number(v);
  return !Number.isNaN(n) && n === 0;
};

const dblclickedRowData = (newValue) => {
  const menuLngCode = menuLngCodeFromPopupRow(newValue);
  const menuLngNum = Number(menuLngCode);
  if (
    menuLngCode === undefined ||
    menuLngCode === null ||
    menuLngCode === "" ||
    Number.isNaN(menuLngNum)
  ) {
    Swal.fire({
      title: "메뉴코드를 확인할 수 없습니다. 행을 다시 선택해 주세요.",
      confirmButtonText: "확인",
    });
    return;
  }

  const a = updatedRowData4.value.find(
    (item) => item.lngCode == optionCd.value
  );
  if (!a) {
    Swal.fire({
      title: "옵션행을 찾을 수 없습니다. 옵션을 다시 선택해 주세요.",
      confirmButtonText: "확인",
    });
    return;
  }

  let placed = false;
  for (let i = 1; i <= 21; i++) {
    const key = `lngChainMenu${i}`;
    if (!isEmptyLngChainMenuSlot(a[key])) {
      if (Number(a[key]) === menuLngNum) {
        Swal.fire({
          title: "이미 등록된 메뉴코드입니다.",
          confirmButtonText: "확인",
        });
        return;
      }
      continue;
    }
    changeColid.value = key;
    changeValue.value = menuLngCode;
    changeNow3.value = !changeNow3.value;
    placed = true;
    break;
  }

  if (!placed) {
    Swal.fire({
      title: "메뉴 연결 슬롯이 가득 찼습니다.",
      confirmButtonText: "확인",
    });
    return;
  }

  closeMenus();
};
/**
 * 행 더블 클릭시 작동 함수
 */

/** 옵션 조회 팝업: 더블클릭 시 JSON 행의 옵션코드 */
const optionLngCodeFromPopupRow = (row) => {
  if (row == null) return undefined;
  if (Array.isArray(row) && row.length > 0) return row[0];
  if (typeof row === "object" && row.lngCode != null && row.lngCode !== "")
    return row.lngCode;
  return undefined;
};

const dblclickedRowData2 = (newValue) => {
  const optLngCode = optionLngCodeFromPopupRow(newValue);
  const optLngNum = Number(optLngCode);
  if (
    optLngCode === undefined ||
    optLngCode === null ||
    optLngCode === "" ||
    Number.isNaN(optLngNum)
  ) {
    Swal.fire({
      title: "옵션코드를 확인할 수 없습니다. 행을 다시 선택해 주세요.",
      confirmButtonText: "확인",
    });
    return;
  }

  const a = updatedRowData5.value.find(
    (item) => item.lngCode == optionGroupCd.value
  );
  if (!a) {
    Swal.fire({
      title: "옵션그룹 행을 찾을 수 없습니다. 그룹을 다시 선택해 주세요.",
      confirmButtonText: "확인",
    });
    return;
  }

  let placed = false;
  for (let i = 1; i <= 20; i++) {
    const key = `lngChainGroup${i}`;
    const slotEmpty =
      a[key] == 0 ||
      a[key] === undefined ||
      a[key] == "0" ||
      a[key] === "" ||
      a[key] === null;
    if (!slotEmpty) {
      if (Number(a[key]) === optLngNum) {
        Swal.fire({
          title: "이미 등록된 옵션코드입니다.",
          confirmButtonText: "확인",
        });
        return;
      }
      continue;
    }
    changeColid.value = key;
    changeValue2.value = optLngCode;
    changeNow4.value = !changeNow4.value;
    placed = true;
    break;
  }

  if (!placed) {
    Swal.fire({
      title: "옵션 연결 슬롯이 가득 찼습니다.",
      confirmButtonText: "확인",
    });
    return;
  }

  closeMenus2();
};
const selectedindex = ref(0);
const selectedindex2 = ref(0);
/**
 * 수정용 데이터 행 설정
 */

const selectedIndex = (newValue) => {
  changeRow.value = newValue;
  selectedindex.value = newValue;
  //comsole.log(selectedindex.value);
};
/**
 * 수정용 데이터 행 설정
 */

const selectedIndex2 = (newValue) => {
  changeRow2.value = newValue;
  selectedindex2.value = newValue;
  ////comsole.log(selectedindex2.value);
};

const changeRow2 = ref();
/**
 * 수정용 데이터 행 설정
 */

const selectedIndex4 = (newValue) => {
  changeRow2.value = newValue;
};
const changeRow3 = ref();
/**
 * 수정용 데이터 행 설정
 */

const selectedIndex3 = (newValue) => {
  changeRow3.value = newValue;
};
/**
 * 조회 초기화
 */

const handleinitAll = (newvalue) => {
  MenuGroup.value = [];
  SubMenuGroup.value = [];
  MenuKeyList.value = [];
  ScreenKeyOrigin.value = [];
  TLUList.value = [];
  AllscreenKeyPage.value = "1";
  MenuList.value = [];
  ScreenKeys.value = [];
  items.value = [];
  forsearchMain.value = "0";
  forsearchSub.value = "0";
  filteredSubMenuGroup.value = [];
  searchword1.value = "";
  searchword3.value = "";
  afterSearch.value = false;
  if (isStoreScopeFeatureEnabled.value) {
    dataScope.value = "COMMON";
    scopeStoreCd.value = normalizeScopeStoreCd(pickedStoreCd.value);
  }
};

const currState = ref("");
const sendRowState = (e) => {
  currState.value = e;
};

const currState2 = ref("");
const sendRowState2 = (e) => {
  currState2.value = e;
};

const allstaterows = ref([]);
const allStateRows = (e) => {
  // console.log(e);
  allstaterows.value = e;
};

const allstaterows2 = ref([]);
const allStateRows2 = (e) => {
  // console.log(e);
  allstaterows2.value = e;
};
</script>

<style scoped>
:deep(.scope-store-select .vs__dropdown-toggle) {
  min-height: 36px;
  height: 36px;
  border-radius: 0.5rem;
  border: 1px solid rgb(209 213 219);
  background-color: white;
}

:deep(.scope-store-select .vs__selected-options) {
  padding: 0 6px;
}

:deep(.scope-store-select .vs__search),
:deep(.scope-store-select .vs__selected) {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

:deep(.scope-store-select .vs__actions) {
  padding-right: 6px;
}
</style>